import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import http from "@/api/http";
import type { IAuth, IUser } from "./interface/login";
import { message } from "antd";

interface State {
  token: string;
  login: any;
  user: IUser | null;
  loading: boolean;
}

const initData: State = {
  token: "",
  login: {
    email: "",
    password: "",
  },
  user: null,
  loading: false,
};

interface Action {
  setToken: (value: any) => void;
  register: (value: any) => Promise<boolean>;
  setLogin: (value: State["login"]) => Promise<boolean>;
  loginWithGoogle: (idToken: string) => Promise<boolean>;
  loginWithFacebook: (accessToken: string) => Promise<boolean>;
  logoutFontend: () => void;
}

const loginStore = create(
  persist<State & Action>(
    (set, _get) => ({
      ...initData,
      setToken: (value) => {
        set(() => ({ token: value }));
      },
      register: async (value) => {
        set({ loading: true });
        try {
          const res = (await http.post("/auth/customer/register", value)) as IAuth;
          if (res.status === 201) {
            set({ token: res.data.token, user: res.data.user, loading: false });
            message.success("Đăng ký thành công!");
            return true;
          }
          set({ loading: false });
          return false;
        } catch (error) {
          console.log("error", error);
          set({ loading: false });
          return false;
        }
      },
      setLogin: async (value) => {
        set({ loading: true });
        try {
          const res = (await http.post("/auth/login", value)) as IAuth;
          if (res.status === 200) {
            set({
              token: res.data.token,
              user: res.data.user,
              loading: false,
            });
            message.success("Đăng nhập thành công!");
            return true;
          }
          set({ loading: false });
          return false;
        } catch (error) {
          set({ loading: false });
          return false;
        }
      },
      loginWithGoogle: async (idToken) => {
        set({ loading: true });
        try {
          const res = (await http.post("/auth/google", { id_token: idToken })) as IAuth;
          if (res.status === 200) {
            set({ token: res.data.token, user: res.data.user, loading: false });
            message.success("Đăng nhập Google thành công!");
            return true;
          }
          set({ loading: false });
          return false;
        } catch (error) {
          set({ loading: false });
          return false;
        }
      },
      loginWithFacebook: async (accessToken) => {
        set({ loading: true });
        try {
          const res = (await http.post("/auth/facebook", { access_token: accessToken })) as IAuth;
          if (res.status === 200) {
            set({ token: res.data.token, user: res.data.user, loading: false });
            message.success("Đăng nhập Facebook thành công!");
            return true;
          }
          set({ loading: false });
          return false;
        } catch (error) {
          set({ loading: false });
          return false;
        }
      },
      logoutFontend: () => {
        set({
          token: "",
          user: null,
        });
      },
    }),
    {
      name: "login-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export { loginStore };
